const handleFileUpload = (event, setFieldValue, fieldName) => {
  const file = event.target.files[0]
  if (file) {
    setFieldValue(fieldName, file)
  }
}

const getImagePreview = image => {
  if (typeof image === "string") {
    // If image is a string, assume it's a URL and return it directly
    return image
  } else if (image instanceof Blob) {
    // If image is a Blob or File object, create a preview URL
    return URL.createObjectURL(image)
  }
  return null // If neither, return null
}

const convertArabicToNumber = numStr => {
  const arabicDigits = "٠١٢٣٤٥٦٧٨٩"
  const englishDigits = "0123456789"

  return numStr
    .split("")
    .map(char => {
      const index = arabicDigits.indexOf(char)
      return index !== -1 ? englishDigits[index] : char // If Arabic, convert; otherwise, keep the same
    })
    .join("")
}

const arabicEnglishDigitRegex = /^[0-9٠-٩]{9,10}$/

export { handleFileUpload, getImagePreview, convertArabicToNumber, arabicEnglishDigitRegex }
